<template>
  <FeatureDetailPage feature-key="schedule" />
</template>
